import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
interface SidebarContextType {
  isSidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
  toggleSidebar: () => void;
}
export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
interface SidebarProviderProps {
  children: ReactNode;
}
export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Wrapper function that automatically saves to localStorage
  const setSidebarCollapsed = (collapsed: boolean) => {
    setIsCollapsed(collapsed);
    localStorage.setItem("sidebarCollapsed", JSON.stringify(collapsed));
  };
  useEffect(() => {
    const savedState = localStorage.getItem("sidebarCollapsed");
    if (savedState !== null) {
      setIsCollapsed(JSON.parse(savedState));
    }
  }, []);
  const toggleSidebar = () => {
    setIsCollapsed(prev => {
      const newState = !prev;
      localStorage.setItem("sidebarCollapsed", JSON.stringify(newState));
      return newState;
    });
  };
  return <SidebarContext.Provider value={{
    isSidebarCollapsed: isCollapsed,
    setSidebarCollapsed,
    toggleSidebar
  }} data-sentry-element="unknown" data-sentry-component="SidebarProvider" data-sentry-source-file="SidebarContext.tsx">
      {children}
    </SidebarContext.Provider>;
};